
import { defineComponent } from 'vue';
import { message } from 'ant-design-vue';
import WarnIcon from '@/components/icons/WarnIcon.vue';
import { getUniqueVin } from '@/api/apis';
import { validateLength } from '@/utils/validate';

export default defineComponent({
  name: 'MultiStatusModal',
  emits: ['after-close'],
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    type: {
      type: Number,
      required: true,
      default: 0 // 1 - 图组进图册 2 - 加入购物车
    },
    isSpare: {
      type: Boolean,
      default: false
    }
  },
  components: {
    WarnIcon
  },
  data() {
    return {
      validateLength,
      visible: true,
      loading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      form: {
        vin: '',
        confirmStatus: 0
      },
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      },
      returnData: {},
      isCancel: true
    };
  },

  methods: {
    handleAfterClose() {
      this.$emit('after-close', this.returnData, this.isCancel);
    },
    handleCancel() {
      this.visible = false;
    },
    handleConfirm() {
      const form = (this.$refs as any).form;
      form
        .validate()
        .then(async () => {
          if (this.form.confirmStatus === 1) {
            const res = await getUniqueVin({
              type: this.type === 1 ? 2 : 3, // 2 - 图组 3 - 子配件,
              vin: this.form.vin,
              name: this.$t(this.item.partName)
            });

            if (res.success) {
              if (!res.result) {
                return;
              }
              const result = res.result || {};
              this.returnData =
                this.type === 1
                  ? {
                      diagramId: result.id
                    }
                  : result;
              this.isCancel = false;
              this.handleCancel();
            } else {
              message.error(this.$t(res.message));
              return;
            }
          } else {
            this.returnData =
              this.type === 1
                ? {
                    diagramId: this.item.id
                  }
                : this.item;
            this.isCancel = false;
            this.handleCancel();
          }
        })
        .catch();
    }
  }
});
